import { render, staticRenderFns } from "./atlas_table_date.vue?vue&type=template&id=1966ad0a&scoped=true&"
import script from "./atlas_table_date.vue?vue&type=script&lang=js&"
export * from "./atlas_table_date.vue?vue&type=script&lang=js&"
import style0 from "./atlas_table_date.vue?vue&type=style&index=0&id=1966ad0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1966ad0a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1966ad0a', component.options)
    } else {
      api.reload('1966ad0a', component.options)
    }
    module.hot.accept("./atlas_table_date.vue?vue&type=template&id=1966ad0a&scoped=true&", function () {
      api.rerender('1966ad0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/atlas/_tool/atlas_table_date.vue"
export default component.exports